import resolve from '../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../modules/apiHelper';

export default {
  async getProgramTaskBadges(context) {
    const programGoals = await context.dispatch('getGoals', [context.rootState.user.companyid, false]);

    const result = await resolve(apiPost('prog_task_badge_list', generateFormData({
      companyid: context.rootState.user.companyid,
      progid: context.rootState.user.programid,
    }), 73))
      .then((res) => {
        if (!res) return false;

        const programGoalsBadges = res.prog_task_badge_list.map((goalBadge) => {
          goalBadge.goal = programGoals.find((goal) => Number(goal.id) === Number(goalBadge.goalid)) || {};

          return goalBadge;
        });

        return programGoalsBadges;
      });
    //

    return result;
  },

  async getTaskBadge(context, taskId) {
    const result = await resolve(apiPost('prog_task_badge_tst_list', generateFormData({
      taskid: taskId,
    }), 73));

    if (result?.prog_task_badge_tst_list?.length) {
      return result.prog_task_badge_tst_list[0];
    }

    return {};
  },

  async assignBadgeToTask(context, { taskId, badgeId, userId }) {
    const result = await resolve(apiPost('prog_badge_ad_task_user', generateFormData({
      taskid: taskId,
      badgeid: badgeId,
      userid: userId,
    }), 3));

    return !!result;
  },

  async getUserTasksBadges(context, userId) {
    const result = await resolve(apiPost('prog_my_task_badge_list', generateFormData({
      userid: userId || context.rootState.user.id,
      progid: context.rootState.user.programid,
    }), 73));

    if (result) {
      context.commit('setUserBadges', result.prog_my_task_badge_list || []);
    }

    return result?.prog_my_task_badge_list || [];
  },
};
